import axios from "axios";
import { API } from "../Common";
let partner_id = localStorage.getItem("partner_id");

var setPartnerId = function () {
    if (partner_id == null) {
        partner_id = localStorage.getItem("partner_id");
    }
};
var getPartnerId = () => {
    return localStorage.getItem("partner_id");
};

export default {
    getFreshOrders: function (id, query = "") {
        return new Promise((resolve, reject) => {
            setPartnerId();
            axios
                .get(API + `orders?restaurant_id=${id}&fresh=true&show_turns=true${query}`)
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.log(error.response);
                    //reject(error && error.response ? error.response.data : error);
                });
        });
    },
    getOrderIn: function (id) {
        return new Promise((resolve, reject) => {
            axios
                .get(API + `orders/${id}?show_turns=true`)
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error && error.response ? error.response.data : error);
                });
        });
    },
    getParentOrder: function (id) {
        return new Promise((resolve, reject) => {
            axios
                .get(API + `orders/parent/${id}`)
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error && error.response ? error.response.data : error);
                });
        });
    },
    putOrderIn: function (id, data) {
        data.phone_1 = data.phone;

        return new Promise((resolve, reject) => {
            axios
                .put(API + `orders/${id}`, data)
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error && error.response ? error.response.data : error);
                });
        });
    },
    archiveOrder: function (id) {
        return new Promise((resolve, reject) => {
            axios
                .put(API + `orders/archive/${id}`)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error && error.response ? error.response.data : error);
                });
        });
    },
    unarchiveOrder: function (id) {
        return new Promise((resolve, reject) => {
            axios
                .put(API + `orders/archive/{${id}`)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error && error.response ? error.response.data : error);
                });
        });
    },
    // TODO: save phoneorder
    putPhoneOrder: function (obj) {
        let data = new FormData();
        // data.append('email', obj.email);

        return new Promise((resolve, reject) => {
            axios
                .post(API + "admin_auth/sign_in/", data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error && error.response ? error.response.data : error);
                });
        });
    },

    checkChanges: function (any_since) {
        return new Promise((resolve, reject) => {
            let data = new FormData();

            axios
                .get(
                    API +
                        "orders?restaurant_id=" +
                        getPartnerId() +
                        "&fresh=true&preorder=false&pickup=false&status[]=succeeded&status[]=received"
                )
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error && error.response ? error.response.data : error);
                });
        });
    },

    archiveOrderItem: function (item_id) {
        return new Promise((resolve, reject) => {
            axios
                .put(API + `order_items/archive/${item_id}`)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error && error.response ? error.response.data : error);
                });
        });
    },

    saveNewOrderItem: function (data) {
        return new Promise((resolve, reject) => {
            axios
                .post(API + "order_items/", data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error && error.response ? error.response.data : error);
                });
        });
    }
};



// WEBPACK FOOTER //
// ./src/services/api/Orders.js